import styled from "styled-components";

export const VideoFrame = styled.iframe`
    width: 100%;
    aspect-ratio: 16 / 9;
`;
